import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import logger from "@/lib/logger/logger-init"

export interface SiteContext {
    site_country: string
    site_language: string
}

/**
 * Extracts locale from pathname (e.g., "/en-se/product" -> "en-se")
 */
export const getLocaleFromPathname = (pathname: string): string => {
    if (!pathname) {
        logger.error("No pathname provided")
        return "en-se" // Default fallback
    }

    const segments = pathname.split("/").filter(Boolean)
    if (segments.length === 0) {
        logger.error("Invalid pathname format")
        return "en-se" // Default fallback
    }

    const locale = segments[0]

    // Validate locale format
    if (!locale || locale.length < 2) {
        logger.error(`Invalid locale in pathname: ${locale}`)
        return "en-se" // Default fallback
    }

    return locale
}

export const useSiteContext = (): SiteContext => {
    const centraSession = useEcommerceStore(state => state.centraSession)

    if (!centraSession.token) {
        return {
            site_country: "",
            site_language: ""
        }
    }

    return {
        site_country: centraSession.metadata.country.code.toUpperCase(),
        site_language: centraSession.metadata.language.toUpperCase()
    }
}
